import React from 'react';
import Bg from '../../images/shapes/shape_title_under_line.svg';

// Commercial, NDAA-compliant surveillance / access-control / intercom brands
// BUILDLAB designs and installs. (No federally banned hardware — e.g. Hikvision,
// Dahua — is specified.) Logos live in public/images/brands/<slug>.png.
const BRANDS = [
    { slug: 'axis', name: 'Axis Communications' },
    { slug: 'verkada', name: 'Verkada' },
    { slug: 'avigilon', name: 'Avigilon' },
    { slug: 'genetec', name: 'Genetec' },
    { slug: 'milestone', name: 'Milestone Systems' },
    { slug: 'hanwha', name: 'Hanwha Vision' },
    { slug: 'ubiquiti', name: 'Ubiquiti UniFi' },
    { slug: 'eagleeye', name: 'Eagle Eye Networks' },
    { slug: 'pelco', name: 'Pelco' },
    { slug: 'butterflymx', name: 'ButterflyMX' },
    { slug: 'ipro', name: 'i-PRO' },
];

const SurveillanceBrands = () => {
    const loop = [...BRANDS, ...BRANDS];
    return (
        <div className="section_space bl-brands">
            <style>{`
                .bl-brands .bl-marquee{position:relative;overflow:hidden;-webkit-mask-image:linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent);mask-image:linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent);}
                .bl-brands .bl-track{display:flex;align-items:center;width:max-content;animation:bl-brand-scroll 50s linear infinite;}
                .bl-brands .bl-marquee:hover .bl-track{animation-play-state:paused;}
                .bl-brands .bl-card{flex:0 0 auto;width:200px;height:108px;margin-right:24px;background:#fff;border:1px solid #eceef3;border-radius:16px;display:flex;align-items:center;justify-content:center;padding:22px 26px;box-shadow:0 6px 22px rgba(20,20,45,.05);transition:transform .25s ease,box-shadow .25s ease;}
                .bl-brands .bl-card:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(20,20,45,.13);}
                .bl-brands .bl-card img{max-width:100%;max-height:54px;object-fit:contain;display:block;}
                @keyframes bl-brand-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}
                @media (max-width:575px){.bl-brands .bl-card{width:152px;height:90px;margin-right:16px;padding:16px 18px}.bl-brands .bl-card img{max-height:44px}}
                @media (prefers-reduced-motion:reduce){.bl-brands .bl-track{animation:none;flex-wrap:wrap;justify-content:center;width:auto;gap:18px}.bl-brands .bl-card{margin-right:0}}
            `}</style>
            <div className="heading_block text-center">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                    Brands We Deploy
                </div>
                <h2 className="heading_text mb-0">
                    Surveillance &amp; Access <mark>Brands</mark> We Install
                </h2>
                <p className="mt-3 mb-0" style={{ maxWidth: 760, marginLeft: 'auto', marginRight: 'auto', color: 'var(--bs-secondary-color)' }}>
                    We design and install enterprise-grade, NDAA-compliant surveillance, access-control,
                    and intercom platforms — never federally banned or restricted hardware.
                </p>
            </div>
            <div className="bl-marquee mt-5" role="list" aria-label="Surveillance and access-control brands BUILDLAB installs">
                <div className="bl-track">
                    {loop.map((b, i) => (
                        <div className="bl-card" role="listitem" key={i} title={b.name} aria-hidden={i >= BRANDS.length ? 'true' : undefined}>
                            <img src={`${process.env.PUBLIC_URL}/images/brands/${b.slug}.png`} alt={`${b.name} logo`} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SurveillanceBrands;
